import * as z from 'zod';
import { CleaningServiceSchema } from '../cleaningServiceSchema';

export const parseCleaningServiceList = (value: unknown) => {
    return z.array(CleaningServiceSchema).parse(value);
};
